define('collection/TimeFlexibleCollection',['require','lib/collection/TimeGroupCollection'],function (require) {

    var TimeGroupCollection = require('lib/collection/TimeGroupCollection');

    /**
     * Flexible timeline collection
     *
     * @class TimeFlexibleCollection
     */
    return TimeGroupCollection.extend({

        url: '/booking/time-flexible/'

    });

});
